import React, { useEffect, useRef, useState } from "react";
import styles from './ImageViewer.module.css';
import { useNavigate, useSearchParams } from "react-router-dom";
import { imgArray2 } from "./ImgArray";
import { ReactComponent as Cross } from '../../icons/cross.svg';
import { ReactComponent as Left } from '../../icons/left.svg';
import { ReactComponent as Right } from '../../icons/right.svg';


export default function ImageViewer({open,setOpen,tag,tagImgs}) {

    const navigate = useNavigate()

    const [searchParams, setSearchParams] = useSearchParams();

    // const [tag,setTag] = useState('');
    const [imgName,setImgName] = useState('');
    const [index,setIndex] = useState(0);
    const [mouseContent,setMouseContent] = useState('');

    const touchStartX = useRef(0);
    const touchEndX = useRef(0);

    const mouseTrackerRef = useRef(null);

    const imageReelRef = useRef();

    const SWIPE_THRESHOLD = 100; // minimum px to count as swipe

    const handleClose = () => {
        setSearchParams((searchParams) => {
            searchParams.set('view',false);
            return searchParams;
        })
    }
    useEffect(() => {
        if(imageReelRef){
            if(open){
                setTimeout(() => {
                    imageReelRef.current.style.transition = "0.5s";
                },500)
            } else {
                imageReelRef.current.style.transition = "0s";
            }
        }
    },[open])
    
    useEffect(() => {
        setOpen(searchParams.get('view') === 'true')
        setImgName(searchParams.get('img'));
    },[searchParams]);

    useEffect(() => {
        if(tagImgs.length > 0){
            const newIndex = tagImgs.findIndex((obj) => obj.imgName === imgName);
            if(newIndex > -1){
                setIndex(newIndex);
            } else {
                setIndex(0);
            }
        }
    },[imgName,tagImgs])

    const previousImg = (close) => {
        setIndex((prev) => {
            if(prev <= 0){
                if(close){
                    handleClose();
                }
                return 0;
            } else {
                return prev - 1
            }
        })
    }

    const nextImg = (close) => {
        setIndex((prev) => {
            if(prev >= tagImgs.length - 1){
                if(close){
                    handleClose();
                }
                return tagImgs.length - 1;
            } else {
                return prev + 1
            }
        })
    }

    useEffect(() => {
        if(tagImgs.length > 0){
            if(tagImgs[index].imgName !== searchParams.get('img')){
                setSearchParams((searchParams) => {
                    searchParams.set('img',tagImgs[index].imgName);
                    return searchParams;
                })
                console.log(tagImgs[index].imgName);
            }
        }
    },[index]);

    const handleTouchStart = (e) => {
        touchStartX.current = e.touches[0].clientX;
    };

    const handleTouchMove = (e) => {
        touchEndX.current = e.touches[0].clientX;
    };

    const handleTouchEnd = () => {
        const distance = touchStartX.current - touchEndX.current;

        if (distance > SWIPE_THRESHOLD) {
            nextImg();
        } else if (distance < -SWIPE_THRESHOLD) {
            previousImg();
        }
    };

    const getPosition = (e) => {
        console.log(e);
        if(!window.mobileCheck()){
            if(e.clientX >= e.target.getBoundingClientRect().right/2){
                nextImg(true);
            } else {
                previousImg(true);
            }
        }
    }

    const hideMouseTracker = () => {
        mouseTrackerRef.current.style.opacity = '0';
    }

    const showMouseTracker = () => {
        mouseTrackerRef.current.style.opacity = '1';
    }

    const mouseMove = (e) => {
        mouseTrackerRef.current.style.top = e.clientY-(1.5*16)+'px';
        mouseTrackerRef.current.style.left = e.clientX+(1.5*16)+'px';
        if(e.clientX >= e.target.getBoundingClientRect().right/2){
            if(index === tagImgs.length - 1){
                setMouseContent('Close');
            } else {
                setMouseContent('Next');
            }
        } else {
            if(index === 0){
                setMouseContent('Close');
            } else {
                setMouseContent('Previous');
            }
        }
    }

    return (
        <div className={styles.fixedDiv} style={{height: `${open? '100vh' : '0'}`}}>
            <div ref={mouseTrackerRef} className={styles.mouseTracker} style={{opacity: '0'}}>{mouseContent}</div>
            <section className={styles.top}>
                <button type="button" className={styles.back} onClick={handleClose}>
                    <Cross />
                </button>
            </section>
            <section className={styles.middle} onClick={getPosition}>
                <div ref={imageReelRef} className={styles.imageReel} onMouseMove={mouseMove} onMouseEnter={showMouseTracker} onMouseLeave={hideMouseTracker} onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} style={{left: `-${index*100}cqw`,gridTemplateColumns: `repeat(${tagImgs.length},100cqw)`}}>
                    {tagImgs.map((imgObject) => <div><img src={imgObject.px2000}/></div>)}
                </div>
            </section>
            <section className={styles.bottom}>
                <div className={styles.bottomNav}>
                    {index === 0? <button type="button" className={styles.previous} onClick={handleClose}>Close</button> : <button type="button" className={styles.previous} onClick={previousImg}><Left /></button>}
                    <div>{index+1}/{tagImgs.length}</div>
                    {index === tagImgs.length - 1? <button type="button" className={styles.next} onClick={handleClose}>Close</button> : <button type="button" className={styles.next} onClick={nextImg}><Right /></button>}
                </div>
            </section>
        </div>
    )
}